/* eslint-disable max-len */
import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="88" height="88" fill="none">
    <path
      d="M28 66l-1.392-.559a1.5 1.5 0 0 0 2.112 1.875L28 66zm9.72-3.607a1.5 1.5 0 1 0-1.44-2.632l1.44 2.632zm-4.683-12.952l-6.429 16 2.784 1.118 6.429-16-2.784-1.118zM28.72 67.316l9-4.923-1.44-2.632-9 4.923 1.44 2.632zM62 66l1.392-.559a1.5 1.5 0 0 1-2.112 1.875L62 66zm-9.72-3.607a1.5 1.5 0 1 1 1.44-2.632l-1.44 2.632zm4.683-12.952l6.429 16-2.784 1.118-6.428-16 2.784-1.118zm4.317 17.875l-9-4.923 1.44-2.632 9 4.923-1.44 2.632z"
      fill="#f5f6fa"
    />
    <g stroke="#f5f6fa" strokeWidth="3">
      <path
        d="M39.597 65h9.493c.501 0 .956-.29 1.157-.749 1.505-3.441 7.545-17.993 6.667-28.078-.752-8.636-7.061-19.592-10.457-24.94-.988-1.556-3.192-1.482-4.083.131-2.998 5.428-8.497 16.364-9.263 24.808-.9 9.924 4.01 24.411 5.298 28 .18.502.656.827 1.19.827z"
        strokeLinejoin="round"
      />
      <circle cx="45" cy="25" r="4" />
      <path d="M42 59.455h6M40 68s2.725 3 4.5 3 4.5-3 4.5-3" strokeLinecap="round" />
      <circle cx="45" cy="37" r="4" />
      <circle cx="45" cy="49" r="4" />
      <path
        d="M20 39.079A11.3 11.3 0 0 0 18.667 39C12.776 39 8 43.549 8 49.16c0 4.734 3.399 8.712 8 9.84m4.066-20A12.31 12.31 0 0 1 20 37.727C20 30.698 25.97 25 33.333 25c.913 0 1.805.088 2.667.255m34 13.824A11.3 11.3 0 0 1 71.333 39C77.224 39 82 43.549 82 49.16c0 4.734-3.399 8.712-8 9.84m-4.062-20L70 37.727C70 30.698 64.404 25 57.5 25a12.34 12.34 0 0 0-2.5.255M25 51c0-4.811 2.974-8.854 7-10m-6.833 10C20.461 52.117 17 55.871 17 60.331 17 65.671 21.962 70 28.083 70A12.67 12.67 0 0 0 31 69.662m33.846-18.034c0-4.588-3.334-8.444-7.846-9.537m7.846 9.86C70.121 53.018 74 56.602 74 60.86c0 5.098-5.562 9.232-12.423 9.232a16.51 16.51 0 0 1-3.269-.323"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path d="M32 70c2.415 5.343 7.33 9 13 9s10.585-3.657 13-9" strokeLinecap="round" />
    </g>
  </svg>
);
